export const sidebarDivider = theme => ({})
